module.exports = __webpack_public_path__ + "img/a2.f035af77.jpeg";